'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { CgProfile } from 'react-icons/cg';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@eliadmin/core/src/components/ui/dropdown-menu';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { PROFILE_DROPDOWN_CONFIG } from '@eliadmin/core/src/constants/PROFILE_DROPDOWN_CONFIG';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const DROPDOWN_CONTENT_CLASSNAME = cn(
  'flex w-full min-w-max max-w-max flex-col items-start justify-start rounded-[16px] border-none bg-white p-4',
  'ea-profile-dropdown-menu-content',
);

const DROPDOWN_ITEM_CLASSNAME =
  'flex w-full items-center justify-start gap-2 rounded-[16px] p-4 text-base font-semibold';

export const HeaderProfileButton = () => {
  const me = useCustomerStore(s => s.me);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const { t } = useTranslations();

  if (!isInitialized) {
    return (
      <Button variant={'outline'} size={'icon'} aria-label={t('text190')} disabled>
        <Spinner />
      </Button>
    );
  }

  const items = me ? PROFILE_DROPDOWN_CONFIG.logged : PROFILE_DROPDOWN_CONFIG.notLogged;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={'outline'}
          size={'icon'}
          aria-label={t('text190')}
          className="data-[state=open]:bg-[#E7E7E9]"
        >
          <CgProfile size={24} className="text-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={10} className={DROPDOWN_CONTENT_CLASSNAME}>
        {items.map(item => (
          <DropdownMenuItem
            key={item.name}
            asChild={!!item.href}
            className={DROPDOWN_ITEM_CLASSNAME}
          >
            {item.href ? (
              item.hardLink ? (
                <a href={item.href()}>
                  {item.icon}
                  {t(item.name)}
                </a>
              ) : (
                <Link href={item.href()}>
                  {item.icon}
                  {t(item.name)}
                </Link>
              )
            ) : (
              <>
                {item.icon}
                {t(item.name)}
              </>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
